import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Model } from 'survey-core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { surveyJSON, buildMmpSurveyTheme } from '@app/shared/models/survey';
import { AuthService } from '@app/shared/auth/auth.service';
import { environment } from '@env/environment';
import { SurveyService } from '@app/shared/services/api/survey.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent implements OnInit {
  @Input() surveyJson: any;
  @Input() surveyData: any;
  @Input() surveyType: 'default' = 'default';
  @Output() surveyCompleted = new EventEmitter<any>();
  @Output() surveyValueChanged = new EventEmitter<any>();
  ApiUrl = environment.apiUrlV2+'/survey';
  surveyModel: Model;
  constructor(
    public activeModal: NgbActiveModal,
    private authService: AuthService,
    private surveyService: SurveyService,
    private toastr: ToastrService) {}

  ngOnInit() {
    // Use the provided surveyJson or fallback to default
    const jsonConfig = this.surveyJson || this.getSurveyConfig();
    
    // Create the survey model
    this.surveyModel = new Model(jsonConfig);
    this.surveyModel.applyTheme(buildMmpSurveyTheme(this.isDarkModeActive()));

    // Set initial data if provided
    if (this.surveyData) {
      this.surveyModel.data = this.surveyData;
    }

    // Add event handlers
    this.surveyModel.onComplete.add((sender: any) => {
      const result: any[] = [];
    
      sender.getAllQuestions().forEach((q: any) => {
        result.push({
          name: q.name,
          question: q.title,
          answer: sender.data[q.name] ?? null
        });
      });
    
      this.surveyCompleted.emit(result);
   
    const payload = {
      set_value: JSON.stringify(result)
    };  
    this.surveyService.submitSurvey(payload).subscribe({
      next: res => {
        this.toastr.success('Survey submitted successfully. We appreciate your feedback!', 'Success!');
      },
      error: err => console.error('❌ Submission failed:', err)
    });


      this.activeModal.close(result);
    });
    

    this.surveyModel.onValueChanged.add((sender: any) => {
      this.surveyValueChanged.emit(sender.data);
    });
  }

  closeSurvey() {
    // Close the modal without completing the survey
    this.activeModal.dismiss('skipped');
  }

  private isDarkModeActive(): boolean {
    return document.documentElement.getAttribute('data-mmp-theme') === 'dark';
  }

  private getSurveyConfig(): any {
    switch (this.surveyType) {
      default:
        return surveyJSON;
    }
  }

  // Method to get current survey data
  getSurveyData(): any {
    return this.surveyModel ? this.surveyModel.data : null;
  }

  // Method to set survey data
  setSurveyData(data: any): void {
    if (this.surveyModel) {
      this.surveyModel.data = data;
    }
  }

  // Method to clear survey
  clearSurvey(): void {
    if (this.surveyModel) {
      this.surveyModel.clear();
    }
  }

  getUserInfo() {
    const first_name = this.authService.getUserData('first_name');
    const last_name = this.authService.getUserData('last_name');
    return { first_name, last_name };
  }

  getUserRole(){
    if(this.authService.isAdmin()){
      return 'Admin';
    }else if(this.authService.isStaff()){
      return 'Staff';
    }else if(this.authService.isAssociate()){
      return 'Associate';
    }
  }
} 